"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var IpexMomentEnum;
(function (IpexMomentEnum) {
    IpexMomentEnum["giveMe"] = "give_me";
    IpexMomentEnum["whatIsMe"] = "what_is_me";
    IpexMomentEnum["showMe"] = "show_me";
    IpexMomentEnum["makeItMe"] = "make_it_me";
    IpexMomentEnum["helpMe"] = "help_me";
    IpexMomentEnum["nonInteraction"] = "non_interaction";
})(IpexMomentEnum || (IpexMomentEnum = {}));
exports.default = IpexMomentEnum;
//# sourceMappingURL=IpexMomentEnum.js.map